export const sepaCountries = [
	{ code: 'AT', name: { en: 'Austria', de: 'Österreich' } },
	{ code: 'BE', name: { en: 'Belgium', de: 'Belgien' } },
	{ code: 'BG', name: { en: 'Bulgaria', de: 'Bulgarien' } },
	{ code: 'HR', name: { en: 'Croatia', de: 'Kroatien' } },
	{ code: 'CY', name: { en: 'Cyprus', de: 'Zypern' } },
	{ code: 'CZ', name: { en: 'Czech Republic', de: 'Tschechien' } },
	{ code: 'DK', name: { en: 'Denmark', de: 'Dänemark' } },
	{ code: 'EE', name: { en: 'Estonia', de: 'Estland' } },
	{ code: 'FI', name: { en: 'Finland', de: 'Finnland' } },
	{ code: 'FR', name: { en: 'France', de: 'Frankreich' } },
	{ code: 'DE', name: { en: 'Germany', de: 'Deutschland' } },
	{ code: 'GR', name: { en: 'Greece', de: 'Griechenland' } },
	{ code: 'HU', name: { en: 'Hungary', de: 'Ungarn' } },
	{ code: 'IE', name: { en: 'Ireland', de: 'Irland' } },
	{ code: 'IT', name: { en: 'Italy', de: 'Italien' } },
	{ code: 'LV', name: { en: 'Latvia', de: 'Lettland' } },
	{ code: 'LT', name: { en: 'Lithuania', de: 'Litauen' } },
	{ code: 'LU', name: { en: 'Luxembourg', de: 'Luxemburg' } },
	{ code: 'MT', name: { en: 'Malta', de: 'Malta' } },
	{ code: 'NL', name: { en: 'Netherlands', de: 'Niederlande' } },
	{ code: 'PL', name: { en: 'Poland', de: 'Polen' } },
	{ code: 'PT', name: { en: 'Portugal', de: 'Portugal' } },
	{ code: 'RO', name: { en: 'Romania', de: 'Rumänien' } },
	{ code: 'SK', name: { en: 'Slovakia', de: 'Slowakei' } },
	{ code: 'SI', name: { en: 'Slovenia', de: 'Slowenien' } },
	{ code: 'ES', name: { en: 'Spain', de: 'Spanien' } },
	{ code: 'SE', name: { en: 'Sweden', de: 'Schweden' } },
	// EEA (non-EU)
	{ code: 'IS', name: { en: 'Iceland', de: 'Island' } },
	{ code: 'LI', name: { en: 'Liechtenstein', de: 'Liechtenstein' } },
	{ code: 'NO', name: { en: 'Norway', de: 'Norwegen' } },
	// Non-EU SEPA countries / territories
	{ code: 'GB', name: { en: 'United Kingdom', de: 'Vereinigtes Königreich' } },
	{ code: 'CH', name: { en: 'Switzerland', de: 'Schweiz' } },
	{ code: 'AD', name: { en: 'Andorra', de: 'Andorra' } },
	{ code: 'MC', name: { en: 'Monaco', de: 'Monaco' } },
	{ code: 'SM', name: { en: 'San Marino', de: 'San Marino' } },
	{ code: 'VA', name: { en: 'Vatican City', de: 'Vatikanstadt' } },
	{ code: 'AL', name: { en: 'Albania', de: 'Albanien' } },
	{ code: 'MK', name: { en: 'North Macedonia', de: 'Nordmazedonien' } },
	{ code: 'MD', name: { en: 'Moldova', de: 'Moldau' } },
	{ code: 'ME', name: { en: 'Montenegro', de: 'Montenegro' } },
	{ code: 'RS', name: { en: 'Serbia', de: 'Serbien' } }
];

export const sepaCountriesSorted = (lang) => sepaCountries.sort((a, b) => {
		if (a.code === 'DE') return -1;
		if (b.code === 'DE') return 1;
		return a.name[lang].localeCompare(b.name[lang]);
	});
